import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { Contact } from 'views/contact'

const ContactPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'contactus.meta.title' })}
        description={formatMessage({ id: 'contactus.meta.description' })}
      />
      <Header bordered={false} />
      <Contact />
      <Footer />
    </>
  )
}

export default ContactPage
